import colors from './colors';
const borders = {
  inputs: `1px solid ${colors.gray5};`,
  error: `1px solid ${colors.error};`,
  radius: '10px',
};

export default borders;
